<template>
    <div id="empresa-cadastro">
        <my-tour :steps="steps" name="steps-cadastro-empresas"></my-tour>
        <section id="content">
            <!--start container-->

            <div class="container">


                <TituloPagina :titulo="lang.empresa" />

                <steps
                    :items="['Dados cadastrais', 'Enviar Logo', 'Tema']"
                    :value="0"
                />

                <div class="row">
                    <div class="col s12 m12 l12">
                        <div id="card-panel" class="card-panel">
                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <formulario-empresa :empresa.sync="formData"></formulario-empresa>
                                    <div class="row">
                                        <div class="input-field col s12 salvar-empresa">
                                            <button class="btn btn-default waves-effect salvar-empresa-btn waves-light right" type="submit" name="action">
                                                Salvar
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
import FormularioEmpresa from "@/components/empresas/Formulario";
import Message from "@/helpers/message";
import { post, get } from "@/helpers/api";
import MyTour from "@/components/common/MyTour.vue";
import TituloPagina from "@/components/common/TituloPagina";
import {
    DONO,
    GERENTE,
    CORRETOR,
    ESPECIALISTA,
    LIDER,
    MASTER,
    PARCEIRO
} from "@/constants/funcionarioCargo.js";
import Auth from "@/store/auth";
import TourHelper from "@/helpers/tour";
import getPalavra from "@/helpers/language";
import swal from "sweetalert2";
import { isMultiEmpresa } from "@/environment";
import InsuranceModal from "./components/InsuranceModal.vue";

import Steps from "@/components/common/Steps.vue";

export default {
    components: {
        FormularioEmpresa,
        MyTour,
        TituloPagina,
        Steps,
        InsuranceModal
    },
    data: () => ({
        formData: {
            empresa_cnpj: '',
            empresa_tipo_id: '',
            empresa_razao_social: '',
            empresa_nome_fantasia: '',
            envia_email: '',
            empresa_seguradora: {
                mapfre_cod2: null,
                mapfre_cod3: null,
                mapfre_cod4: null,
                mapfre_cod5: null,
            },
            parent: null,
            parent_id: null,
            seguradoras: []
        },
        lang: {
            empresa: `Cadastro de ${getPalavra('empresa', true)} parceira`
        },
        cargoDono: null,
        cargoGerente: null,
        cargoCorretor: null,
        cargoParceiro: null,
        steps: [
            {
                parent: '.card-panel',
                target: '.card-panel',
                content: `É necessário preencher os campos com as informações da ${getPalavra('empresa', true)}!`,
                params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'bottom',
                    menu: false
                }
            },
            {
                parent: '.salvar-empresa-btn',
                target: '.salvar-empresa-btn',
                content: 'E clicar em salvar!',
                params: { cargos: isMultiEmpresa ? [DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER] : [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'left',
                    menu: false
                }
            },
            {
                parent: '#left-sidebar-nav',
                target: '#listagem_funcionarios',
                content: 'Para ver os funcionários cadastrados ou adicionar novos, basta no menu Funcionários clicar em <b>Listagem</b>!',
                params: { cargos: isMultiEmpresa ? [DONO, GERENTE, CORRETOR, ESPECIALISTA, LIDER] : [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'left',
                    menu: true,
                    route: '/usuarios',
                    subMenu: true,
                    subMenuTarget:"#group-funcionarios"
                }
            },
            {
                parent: '',
                target: '',
                content: '',
                params: { cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
                    placement: 'left',
                    menu: false,
                    // route: '/gerenciamento-leads'
                }
            }
        ]
    }),
    created() {
        // verifica se pode acessar componente
        if (Auth.getCargoUsuario() !== MASTER && [DONO, GERENTE, PARCEIRO, ESPECIALISTA].indexOf(Auth.getCargoUsuario()) === -1) {
            this.$router.push('/sempermissao');
        }
        this.steps = TourHelper.createSteps(this.steps);
        this.cargoDono = DONO;
        this.cargoGerente = GERENTE;
        this.cargoCorretor = CORRETOR;
    },
    methods: {
        validateForm() {
            let formValid = true;
            if (this.formData.empresa_cnpj === '') {
                Message.messageError('Campo CNPJ é obrigatório.');
                formValid = false;
            }
            if (this.formData.empresa_tipo_id === '') {
                Message.messageError('Campo Tipo é obrigatório.');
                formValid = false;
            }
            if (this.formData.empresa_razao_social === '') {
                Message.messageError('Campo Razão Social é obrigatório.');
                formValid = false;
            }
            if (this.formData.empresa_nome_fantasia === '') {
                Message.messageError('Campo Nome Fantasia é obrigatório.');
                formValid = false;
            }
            return formValid;
        },
        save() {
            if (!this.validateForm()) {
                return false;
            }

            let postData = {
                ...this.formData,
                empresa_cnpj: this.removerCarateresNaoNumericos(this.formData.empresa_cnpj),
                telefone: this.removerCarateresNaoNumericos(this.formData.telefone)
            };


            let self = this;

            post('empresa', postData).then(({data: {result: {data: empresa}}}) => {

                        Message.messageSuccess('Empresa salva com sucesso.');

                    this.$router.push({name: 'empresa_upload_logo', params: {id: empresa.empresa_id}});

                }).catch((err) => {
                    if (err.response) {
                        const { message: errors } = err.response.data;

                        if (typeof errors === 'object') {
                            if (errors.empresa_cnpj) {
                                Message.messageError(errors.empresa_cnpj[0]);
                                return;
                            }
                        }
                    }

                    Message.messageError('Erro ao salvar a empresa.');
                });
        },

        removerCarateresNaoNumericos(string) {
            return string.replace(/\D+/g, "");
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/empresas/Cadastro.vue